import { render, staticRenderFns } from "./OrderZx.vue?vue&type=template&id=456a6e6e&scoped=true&"
import script from "./OrderZx.vue?vue&type=script&lang=js&"
export * from "./OrderZx.vue?vue&type=script&lang=js&"
import style0 from "./OrderZx.vue?vue&type=style&index=0&id=456a6e6e&prod&scoped=true&lang=css&"
import style1 from "./OrderZx.vue?vue&type=style&index=1&id=456a6e6e&prod&media=print&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a6e6e",
  null
  
)

export default component.exports